"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../../config");
var Icon_1 = __importStar(require("../../Icon"));
var Burger = /** @class */ (function (_super) {
    __extends(Burger, _super);
    function Burger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
        };
        _this.toggle = function () {
            _this.setState({ open: !_this.state.open });
        };
        return _this;
    }
    Burger.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.open !== prevState.open) {
            if (this.state.open) {
                document.body.classList.add("menu-open");
            }
            else {
                document.body.classList.remove("menu-open");
            }
        }
    };
    Burger.prototype.render = function () {
        var className = this.props.className;
        var b = config_1.block("burger");
        return (react_1.default.createElement("a", { href: "javascript:void(0);", className: b({}).mix(className), onClick: this.toggle },
            react_1.default.createElement(Icon_1.default, { icon: this.state.open ? Icon_1.IconType.Cross : Icon_1.IconType.Burger, width: 24, height: 24 })));
    };
    return Burger;
}(react_1.default.Component));
exports.default = Burger;
//# sourceMappingURL=index.js.map